$('.arrivals_slider01').slick({
  prevArrow: false,
  nextArrow: false,
  dots: true,
  fade: true,
});
$('.arrivals_slider02').slick({
  prevArrow: false,
  nextArrow: false,
  dots: true,
  fade: true,
});
$('.slick-carousel').slick({
  speed: 5000,
  autoplay: true,
  infinite: true,
  autoplaySpeed: 0,
  cssEase: 'linear',
  slidesToShow: 2.36,
  slidesToScroll: 2.36,
  pauseOnHover: true,
  prevArrow: false,
  nextArrow: false,
  // responsive: [{
  //   breakpoint: 480,
  //   settings: {
  //     slidesToShow: 4,
  //   }
  // }]
});
$(".slick-bnr").slick({
  speed: 500,
  autoplay: true,
  infinite: true,
  autoplaySpeed: 4000,
  cssEase: 'linear',
  slidesToShow: 1,
  slidesToScroll: 1,
  pauseOnHover: true,
  prevArrow: false,
  nextArrow: false,
});

  /*
  const basePath = 'https://cdn.shopify.com/videos/c/o/v/';
  const movies = [
    '323ab24c1fdf4d48aba41f2542001c4b.mp4'
    // '294f9db6093948598ecf772f3c8d741f.mp4'
    // '098bfb2e5b2e4dada87b41d59e4d96e1.mp4'
    // '3b0ec48f680043f2ae2ee397851fbe96.mp4',
    // '1eed154ef6784d0b8a5bac535489a969.mp4'
  ].map(movie => basePath + movie);  // ベースパスを追加
  */

